export enum PopupStateCommand{
    NOTHING=0,
    CLOSE=1,
    SHOW=2,
}
